export default __webpack_public_path__ + "static/feature2-6e9b544acd7d2e708b0f90349bf6917e.png";